// reducers/index.js
import { combineReducers } from 'redux';
import counterReducer from './counterReducer';
import ordersReducer from './ordersReducer';

const rootReducer = combineReducers({
  counter: counterReducer,
  orders: ordersReducer
});

export default rootReducer;
